export default function NotFound() {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      textAlign: "center",
      fontFamily: "Arial, sans-serif",
      padding: "20px"
    }}>
      
      <img
        src="https://www.betongsentrum.no/wp-content/uploads/2018/08/Logo-11-150x250.png"
        alt="Betongsentrum Logo"
        style={{ marginBottom: "30px" }}
      />

      <h1 style={{ color: "#006bb7", marginBottom: "10px" }}>
        Oi!
      </h1>

      <h3 style={{ marginBottom: "15px" }}>
        Siden eller produktet du ser etter er deaktivert!
      </h3>

      <p>
        Ta{" "}
        <a 
          href="mailto:post@betongsentrum.no" 
          style={{ color: "#006bb7", textDecoration: "none", fontWeight: "bold" }}
        >
          kontakt med oss
        </a>{" "}
        hvis du fortsatt ønsker tilgang.
      </p>

    </div>
  );
}